import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { motion } from "framer-motion";

import { ANIMATION_CONFIG } from "./ReactionsWrapper";

export const ReactionIcon = ({ icon, name, setLike }) => {
  return (
    <motion.div
      className="reaction-icon"
      role="button"
      variants={ANIMATION_CONFIG}
      onClick={() => setLike(name)}
    >
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-tooltip">{name}</Tooltip>}
      >
        <img src={icon} />
      </OverlayTrigger>
    </motion.div>
  );
};
